/**
 * The empty read-only placeholder. Every platform renders it grey and
 * italic; only the wording changes.
 */
export const NO_VALUE_AVAILABLE_TEXT = 'No value available'

export interface NoValueAvailableProps {
  /**
   * Domain-specific wording, e.g. 'No files available', 'No images
   * available', 'QR code not available'. Defaults to the generic
   * `NO_VALUE_AVAILABLE_TEXT`. Fields set a sensible default and let
   * `emptyText` from uiSchema override it.
   */
  text?: string
  /** Platform-specific style override (RN StyleProp on mobile, CSSProperties on web). */
  style?: unknown
}
